import React, {useState, useRef, useEffect} from 'react';
import ActionItemList from "./ActionItemList.mjs";
import ActionItemListItemMessage from "./ActionItemListItemMessage.mjs";
import LongListDefaultMessage from "./LongListDefaultMessage.mjs";
import { useCTAL } from './CTAL_Hooks.js';

export default function LongListActionItemList() 
{
    const { team_id, setActionItem, action_item_long_list_refresh, setActionItemLongListRefresh } = useCTAL();

    const [action_item_list_ready, setActionItemListReady] = useState(false);
    const [action_item_list, setActionItemList] = useState([]);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const fetchRef = useRef("");

    useEffect(() =>
    {
        if (!team_id) return;
        
        if ((fetchRef.id == team_id) && (!action_item_long_list_refresh)) return;
        
        fetchRef.id = team_id;
        setActionItemLongListRefresh(false);

        var type = "get_team_list_open_action_items";
        var search_body = JSON.stringify({type, team_id});  
        
        setLoading(true);
        setActionItemListReady(false);

        console.log(`LongListActionItemList - fetching User Long List Action-Item List from ctal-get for: ${team_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(setActionItemList)
            .then(() => setLoading(false))
            .catch(setError);
    }, [team_id, action_item_long_list_refresh]);
    
    useEffect(() =>
    {
        if (!loading) setActionItemListReady(true); //Don't display ActionItemlist until it's ready
    }, [action_item_list]);

    if (error) return <ActionItemListItemMessage message={JSON.stringify(error, null, 2)} /> 

    if (!action_item_list) { setActionItem(undefined); return; }
    if (!loading && action_item_list_ready && (action_item_list.length == 0)) { setActionItem(undefined); return <> <LongListDefaultMessage /> </>; }

    return ( <> <ActionItemList action_item_list={action_item_list}/> </> );
}
